import { useState } from 'react';

const MOBILE_TABLET_UA_REGEX = /android|iphone|ipad|ipod|mobile|tablet|silk|kindle|playbook/i;

function detect() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || '';
  // iPadOS 13+ reporta como "MacIntel" no userAgent, então precisa do touch para diferenciar de um Mac.
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return MOBILE_TABLET_UA_REGEX.test(ua) || isIPadOS;
}

// true em celulares e tablets, que possuem câmera acessível via input[type=file][capture].
// Baseado no dispositivo (user agent), não na largura da viewport, para não variar ao redimensionar a janela no desktop.
export function useIsMobileOrTablet() {
  const [isMobileOrTablet] = useState(detect);
  return isMobileOrTablet;
}
